export default __webpack_public_path__ + "static/media/안주7.f22783dc.png";